import type { FeatureFlags } from '@/types/site-config';

export function isFeatureEnabled(feature: keyof FeatureFlags, features: FeatureFlags): boolean {
  const value = features[feature];
  if (typeof value === 'boolean') return value;
  if (typeof value === 'object' && value !== null) return value.enabled;
  return false;
}
